import { Component, Host, Prop, h } from '@stencil/core';

import { ConsumerMarketConfidence } from '../../../../interfaces/interface.consumer-market-confidence';

@Component({
  tag: 'key-factors',
  styleUrl: 'key-factors.css',
})
export class KeyFactors {
  @Prop() keyFactors: ConsumerMarketConfidence[] = [];
  @Prop() shouldDisplayKeyFactors: boolean = false;

  private modal: HTMLKeyFactorConditionDialogElement;

  onConditionDescriptionOpen() {
    this.modal.open();
  }

  render() {
    const { keyFactors, shouldDisplayKeyFactors } = this;

    if (!shouldDisplayKeyFactors) {
      return null;
    }

    return (
      <Host>
        <div class="@container">
          <div class="bg-clrs-white rounded-lg shadow-drop mb-7 @xs:px-6 @md:px-12 py-6" data-testId="key-factors">
            <div class="flex flex-col text-black font-open-sans">
              <h3 class="mb-1.5 font-extrabold text-lg font-montserrat">Key Factors Influencing Your Instant Cash Offer</h3>
              <span class="text-sm">Your Instant Cash Offer is determined by vehicle specific impacts and other considerations.</span>
              <div class="flex flex-col py-5 @lg:pl-7">
                {keyFactors.map((factor) => (
                  <key-factor-element keyFactor={factor} onModalOpen={() => this.onConditionDescriptionOpen()}></key-factor-element>
                ))}
              </div>
              <div class="text-xxs text-clrs-charcoal" aria-label="Offer disclaimer">
                <span>
                  Instant Cash Offer Breakdown and individual adjustments for exterior color, mileage, equipment and condition applies only to your Offer and is not applicable to
                  other Kelley Blue Book value types including Trade-In and Private party. Dealer inspection required the Offer amount may be decreased.
                </span>
              </div>
            </div>
          </div>
        </div>
        <key-factor-condition-dialog ref={(el) => (this.modal = el as HTMLKeyFactorConditionDialogElement)}></key-factor-condition-dialog>
      </Host>
    );
  }
}
